import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { callApi, CDN_URL } from "../Helpers";
import { STR_BUY_NOW, STR_FEMALE, STR_GENDER, STR_INVALID_GENDER, STR_INVALID_USERNAME, STR_MALE, STR_PURCHASE_SUBSCRIPTION_PACKAGE, STR_SUBMIT, STR_SUBSCRIPTION_HAS_EXPIRED, STR_SUCCESS, STR_UPDATE_PERSONAL_INFO, STR_USERNAME } from "../Strings";
import { MdOutlineWarning, MdWarning } from "react-icons/md";

export default function View({ title }) {
  const appContext = useContext(AppContext);

  /* Place states here */
  const [username, setUsername] = useState(appContext.currentUserData?.username || "");
  const [gender, setGender] = useState(appContext.currentUserData?.gender || "");
  const [loading, setLoading] = useState(false);

  async function submit() {
    if (username && username.trim().length > 0) {
      if (gender && gender.trim().length > 0) {
        setLoading(true);
        await callApi("update-username-and-gender", { username, gender }).then(async response => {
          if (response.status === 1) {
            appContext.getCurrentUserData();
            appContext.tellMessage(STR_SUCCESS[appContext.language]);
            appContext.navBack();
          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);
      } else {
        appContext.tellError(STR_INVALID_GENDER[appContext.language])
      }
    } else {
      appContext.tellError(STR_INVALID_USERNAME[appContext.language])
    }
  }

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [loading])

  return (
    <div
      className="card"

    >
      <div className="card-body">

        {
          (title) ?
            <h6
              style={{
                fontSize: "16px",
              }}
              className="font-semi-bold text-secondary text-center mb-4"
            >
              <MdWarning size={70} /> <br />
              {title}
            </h6>
            :
            ""
        }

        <div className="mb-2">
          <label className="form-label">{STR_USERNAME[appContext.language]}</label>
          <input
            className="form-control"
            onChange={(e) => {
              if (e.target.value.length <= 30) {
                setUsername(e.target.value)
              }
            }}
            value={username}
            maxLength={30}
          />
          <div className="form-text">{username.length}/30</div>
        </div>

        <div className="mb-2">
          <label className="form-label">{STR_GENDER[appContext.language]}</label>
          <select
            className="form-control"
            onChange={(e) => {
              setGender(e.target.value)
            }}
            value={gender}
          >
            <option value=""></option>
            <option value="male">{STR_MALE[appContext.language]}</option>
            <option value="female">{STR_FEMALE[appContext.language]}</option>
          </select>
        </div>

        <div className="text-end">
          <button
            className="btn btn-rounded btn-padded btn-secondary mt-4 mb-4"
            onClick={submit}
          >
            {STR_SUBMIT[appContext.language]}
          </button>
        </div>
      </div>
    </div>
  );
}
